module.exports = __webpack_public_path__ + "img/bp_giftbg_0005.efe86e22.png";